module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid23_1080x788.eefeaae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid23_1080x788.jpg
// module id = Z9zp
// module chunks = 0